import { render, staticRenderFns } from "./FrzChamberSearchPallet.vue?vue&type=template&id=5fa3c455"
import script from "./FrzChamberSearchPallet.vue?vue&type=script&lang=js"
export * from "./FrzChamberSearchPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports